<div
  class="flex flex-col gap-12 lg:gap-15 px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-8 lg:py-12 w-full"
>
  <!-- 타이틀 -->
  <div class="text-center flex flex-col gap-4">
    <p class="sb-aggro text-zinc-500 text-sm lg:text-base">
      Preparation schedule
    </p>
    <h1 class="text-2xl lg:text-4xl text-zinc-800">참가업체 준비일정</h1>
  </div>

  <div class="flex flex-col gap-8">
    @for (schedule of schedules; track schedule.title) {
    <div class="bg-zinc-100 rounded-xl overflow-hidden">
      <div
        class="grid grid-cols-1 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-zinc-100"
      >
        <div
          class="lg:col-span-1 flex items-start lg:items-center justify-center bg-zinc-100 px-6 pt-5 pb-3 lg:py-0"
        >
          <h1 class="text-lg lg:text-xl text-zinc-800">
            {{ schedule.title }}
          </h1>
        </div>

        <div
          class="relative lg:col-span-3 divide-y divide-zinc-100 bg-white border-8 rounded-r-2xl border-zinc-100"
        >
          <app-icon
            name="material-symbols:play-arrow-rounded"
            class="absolute -left-2 text-zinc-100 top-1/2 -translate-y-1/2 size-6! hidden! lg:flex!"
          />
          @for (item of schedule.items; track $index) {
          <div
            class="px-6 py-4 flex flex-col lg:flex-row items-center gap-3 lg:gap-6"
          >
            <div class="shrink-0 w-full lg:w-32 text-start">
              <span class="sb-aggro text-base text-zinc-800">
                {{ item.time }}
              </span>
            </div>
            <div class="flex-1 w-full text-start">
              <p class="text-base text-zinc-800">
                {{ item.description }}
              </p>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }
  </div>
</div>
